import React from 'react';
import { Box, Typography } from '@mui/material';
import { Business as BusinessIcon, Build as BuildIcon, CalendarToday as CalendarIcon, Folder as FolderIcon, LocalOffer as LocalOfferIcon, Language as LanguageIcon, Hub as HubIcon, BusinessCenter as BusinessCenterIcon, Group as GroupIcon, ShoppingCart as ShoppingCartIcon, RocketLaunch as RocketLaunchIcon, Mail as MailIcon, ShoppingBasket as ShoppingBasketIcon, Error as ErrorIcon, Assignment as AssignmentIcon, Wifi as WifiIcon, Book as BookIcon, AccountBalance as AccountBalanceIcon, Inventory as InventoryIcon, CheckCircle as CheckCircleIcon, Person as PersonIcon, Store as StoreIcon, Factory as FactoryIcon, AccountTree as AccountTreeIcon, People as PeopleIcon, Settings as SettingsIcon } from '@mui/icons-material';
import Header from '@/__core/layout/Header';
import { PageTitleProvider, usePageTitle } from '@/__core/layout/PageTitleContext';
import { useNavigate } from 'react-router-dom';

interface AppItem {
  id: string;
  name: string;
  icon: React.ReactNode;
  color: string;
  notifications?: number;
  route?: string;
  order: number;
}

const AppsContent: React.FC = () => {
  const { setTitle } = usePageTitle();
  const navigate = useNavigate();
  
  React.useEffect(() => {
    setTitle('Apps');
  }, [setTitle]);

  const handleAppClick = (app: AppItem) => {
    if (app.route) {
      navigate(app.route);
    }
  };

  const appItems: AppItem[] = [
    {
        id: 'human-resources',
        name: 'Nhân sự',
        icon: <GroupIcon />,
        color: '#4caf50',
        route: '/employees',
        order: 1,
    },
    {
        id: 'organization',
        name: 'Tổ chức',
        icon: <AccountTreeIcon />,
        color: '#2196f3',
        route: '/organization',
        order: 2,
    },
    {
        id: 'users',
        name: 'Users',
        icon: <PeopleIcon />,
        color: '#673ab7',
        route: '/users',
        order: 3,
    },
    {
      id: 'sales-order',
      name: 'Sales Order',
      icon: <LocalOfferIcon />,
      color: '#009688',
      route: '/sale-orders',
      order:4,
    },
    {
      id: 'customer',
      name: 'Customer',
      icon: <PersonIcon />,
      color: '#009688',
      route: '/customers',
      order: 5,
    },
    {
      id: 'item',
      name: 'Item',
      icon: <BusinessIcon />,
      color: '#ff9800',
      order: 6,
    },
    {
      id: 'tools',
      name: 'Tools',
      icon: <CalendarIcon />,
      color: '#fff59d',
      order: 7,
    },
    {
      id: 'meeting',
      name: 'Meeting',
      icon: <FolderIcon />,
      color: '#9e9e9e',
      order: 8,
    },
    {
      id: 'file-manager',
      name: 'File Manager',
      icon: <FolderIcon />,
      color: '#8d6e63',
      order: 8,
    },
    {
      id: 'bom',
      name: 'BOM',
      icon: <BuildIcon />,
      color: '#424242',
      order: 9,
    },
    {
      id: 'website',
      name: 'Website',
      icon: <LanguageIcon />,
      color: '#4caf50',
      order: 11,
    },
    {
      id: 'integrations',
      name: 'Integrations',
      icon: <HubIcon />,
      color: '#4caf50',
      order: 12,
    },
    {
      id: 'supplier',
      name: 'Supplier',
      icon: <BusinessCenterIcon />,
      color: '#f44336',
      order: 13,
    },
   
   
    {
      id: 'project',
      name: 'Project',
      icon: <RocketLaunchIcon />,
      color: '#9c27b0',
      notifications: 1,
      order: 14,
    },
    {
      id: 'email-inbox',
      name: 'Email Inbox',
      icon: <MailIcon />,
      color: '#9e9e9e',
      order: 15,
    },
    {
      id: 'purchase-order',
      name: 'Purchase Order',
      icon: <ShoppingBasketIcon />,
      color: '#f44336',
      order: 16,
    },
    {
      id: 'issue',
      name: 'Issue',
      icon: <ErrorIcon />,
      color: '#424242',
      order: 17,
    },
    {
      id: 'production-order',
      name: 'Production Order',
      icon: <BuildIcon />,
      color: '#424242',
      order: 18,
    },
    {
      id: 'lead',
      name: 'Lead',
      icon: <WifiIcon />,
      color: '#03a9f4',
      order: 19,
    },
    {
      id: 'task',
      name: 'Task',
      icon: <AssignmentIcon />,
      color: '#9c27b0',
      notifications: 6,
      order: 20,
    },
    {
      id: 'contacts',
      name: 'Contacts',
      icon: <BookIcon />,
      color: '#e91e63',
      order: 21,
    },
    {
      id: 'profit-loss',
      name: 'Profit and Loss Stat...',
      icon: <BookIcon />,
      color: '#03a9f4',
      order: 22,
    },
    {
      id: 'accounts',
      name: 'Accounts',
      icon: <AccountBalanceIcon />,
      color: '#03a9f4',
      order: 23,
    },
    {
      id: 'stock',
      name: 'Stock',
      icon: <InventoryIcon />,
      color: '#ff9800',
      order: 24,
    },
 
    {
      id: 'todo',
      name: 'ToDo',
      icon: <CheckCircleIcon />,
      color: '#fff59d',
      route: '/dashboard',
      order: 25,
    },
    {
      id: 'crm',
      name: 'CRM',
      icon: <PersonIcon />,
      color: '#e91e63',
      order: 26,
    },
    {
      id: 'selling',
      name: 'Selling',
      icon: <StoreIcon />,
      color: '#009688',
      order: 27,
    },
    {
      id: 'buying',
      name: 'Buying',
      icon: <ShoppingCartIcon />,
      color: '#f44336',
      order: 28,
    },
    {
      id: 'manufacturing',
      name: 'Manufacturing',
      icon: <FactoryIcon />,
      color: '#424242',
      order: 29,
    },
    {
      id: 'settings',
      name: 'Settings',
      icon: <SettingsIcon />,
      color: '#607d8b',
      route: '/settings',
      order: 30,
    },
  ];

    return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Header sidebarOpen={false} onToggleSidebar={() => {}} />

      {/* Main content - Apps grid */}
      <Box sx={{ 
        flex: 1, 
        backgroundColor: '#1a237e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        overflow: 'auto'
      }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 2, maxWidth: 1000, alignItems: 'center', justifyContent: 'center' }}>
          {appItems.sort((a, b) => a.order - b.order).map((app) => (
            <Box 
              key={app.id}
              onClick={() => handleAppClick(app)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: app.route ? 'pointer' : 'default',
                transition: 'all 0.2s ease-in-out',
                p: 0.5,
                '&:hover': {
                  transform: app.route ? 'translateY(-2px)' : 'none',
                },
              }}
            >
              <Box sx={{ position: 'relative', display: 'inline-block',   mb: 1 }}>
                <Box
                  sx={{
                    width:50,
                    height: 50,
                    backgroundColor: app.color,
                    borderRadius: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <Box sx={{ color: 'white', fontSize: '1.2rem' }}>
                    {app.icon}
                  </Box>
                  {app.notifications && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        backgroundColor: '#f44336',
                        color: 'white',
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {app.notifications}
                    </Box>
                  )}
                </Box>
              </Box>
              <Typography
                variant="body2"
                sx={{
                  color: 'white',
                  fontWeight: 500,
                  fontSize: '0.75rem',
                  lineHeight: 1.2,
                  textAlign: 'center',
                }}
              >
                {app.name}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const Apps: React.FC = () => {
  return (
    <PageTitleProvider>
      <AppsContent />
    </PageTitleProvider>
  );
};

export default Apps;
